<template>
  <div>
<InventoryPageHeader>
  <template #title>
    <i class="fas fa-cog mr-2 text-primary"></i>Settings
  </template>
</InventoryPageHeader>
    <b-container fluid class="mt--6">
      <b-row>
        <b-col md="6">
          <b-card no-body class="card-shadow mb-4">
            <b-card-header><i class="fas fa-list mr-2"></i>Status Presets</b-card-header>
            <b-card-body>
              <b-list-group flush>
                <b-list-group-item v-for="s in statuses" :key="s" class="d-flex justify-content-between">
                  {{ s }} <base-button size="sm" type="outline-danger">×</base-button>
                </b-list-group-item>
              </b-list-group>
              <b-input-group size="sm" class="mt-3">
                <b-form-input placeholder="New status..." />
                <b-input-group-append><base-button type="primary">Add</base-button></b-input-group-append>
              </b-input-group>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col md="6">
          <b-card no-body class="card-shadow mb-4">
            <b-card-header><i class="fas fa-exclamation-triangle mr-2"></i>Quality Issue Templates</b-card-header>
            <b-card-body>
              <b-list-group flush>
                <b-list-group-item v-for="i in issues" :key="i" class="d-flex justify-content-between">
                  {{ i }} <base-button size="sm" type="outline-danger">×</base-button>
                </b-list-group-item>
              </b-list-group>
              <b-input-group size="sm" class="mt-3">
                <b-form-input placeholder="New issue template..." />
                <b-input-group-append><base-button type="primary">Add</base-button></b-input-group-append>
              </b-input-group>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import InventoryPageHeader from '@/components/InventoryPageHeader.vue'

export default {
        components: { InventoryPageHeader },

  data() {
    return {
      statuses: ['OK', 'RMA to 4Mod', 'RMA to Freiburg', 'Sold', 'Test'],
      issues: ['Housing cracked', 'Bad speaker', 'Bad buttons', 'Battery issue', 'Screen broken']
    }
  }
}
</script>